<template>
  <div class="slot-box">
    <div class="flex-one">
      <div class="net-work-row flex-layout align-center">
        <div class="net-work-port" v-for="(item, index) in list.filter(data => data.value < 9)" v-if="list.length > 4">
          <div class="port-item port-item-one" :style="calcStyle(item.portNum)">
            <el-popover placement="top" popper-class="sakura-child-port-popover" trigger="click"
                        :disabled="!checkFanout(item.portNum)" @show="fanoutChange(item.portNum)"
                        @hide="fanoutChange()">
              <template #reference>
                <sakura-port-lan
                  @port-click="() => { emit('port-click', item) }"
                  @port-click-fanout="() => { emit('port-click-fanout', item) }"
                  @change="(num) => emit('change', num, item)"
                  :type="item.type"
                  :isEnabledTu="isEnabledTu && item.isEnabledTu"
                  v-model:tu="item.tu"
                  @update:tu="val => item.tu = val"
                  :port="item.portNum"
                  :popover="popover"
                  :isEnabled="isEnabled && item.isEnabled"
                  :status="item.status"
                  :borderStatus="item.borderStatus"
                  :value="item.selected"
                  v-model="item.selected"
                  :hex="item.hex"
                  :mode="item.mode"
                  :detach="item.detach"
                  :lag="item.lag"
                  :priority="item.priority"
                  :vendor="item.detect"
                  :config="item.config"
                  :isFanout="checkFanout(item.portNum)"
                  portShowLock
                >
                  {{ item.value }}
                </sakura-port-lan>
              </template>
            </el-popover>
          </div>
        </div>
        <div class="full-size" v-if="list.length === 4">
          <div class="slot-id-header">{{slotId}}</div>
          <div class="flex-container">
            <div class="net-work-port" v-for="(item, index) in slotList(1)" :key="index">
              <div class="port-item" :style="calcStyle(item.portNum)">
                <el-popover placement="top" popper-class="sakura-child-port-popover" trigger="click"
                            :disabled="!checkFanout(item.portNum)" @show="fanoutChange(item.portNum)"
                            @hide="fanoutChange()">
                  <template #reference>
                    <sakura-port-lan @port-click="() => { emit('port-click', item) }" @update:tu="val => item.tu = val"
                                           @port-click-fanout="() => { emit('port-click-fanout', item) }"
                                           @change="(num) => emit('change', num, item)" :type="item.type"
                                           :isEnabledTu="isEnabledTu && item.isEnabledTu" v-model:tu="item.tu" :port="item.portNum" :popover="popover"
                                           :isEnabled="isEnabled && item.isEnabled" :status="item.status" :borderStatus="item.borderStatus"
                                           :value="item.selected"
                                           v-model="item.selected" :hex="item.hex" :mode="item.mode" :detach="item.detach" :lag="item.lag"
                                           :priority="item.priority" :vendor="item.detect" :config="item.config"
                                           :isFanout="checkFanout(item.portNum)" :slotShowLock="slotShowLock"
                    >
                      {{ item.value }}
                    </sakura-port-lan>
                  </template>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--second row -->
      <div class="net-work-row flex-layout align-center" :style="list.length > 4 ? 'width: 100%; position: relative' : ''">
        <div>
          <img v-if="list.length > 4" src="/static/images/common/computer-fan.png" alt="fan"
               style="width: 135px;
                position: absolute;
                top: 15%;
                left: 4.5%;">
        </div>
        <!-- Layout spacing blocks for fan area -->
        <div class="layout-spacer" v-if="list.length > 4"></div>
        <div class="layout-spacer" v-if="list.length > 4"></div>

        <div class="net-work-port" v-for="(item, index) in list.filter(data => !((data.value % 2) === 0) && data.value > 8)">
          <div class="port-item port-item-one" :style="calcStyle(item.portNum)">
            <el-popover placement="top" popper-class="sakura-child-port-popover" trigger="click"
                        :disabled="!checkFanout(item.portNum)" @show="fanoutChange(item.portNum)"
                        @hide="fanoutChange()">
              <template #reference>
                <sakura-port-lan @port-click="() => { emit('port-click', item) }"
                                       @port-click-fanout="() => { emit('port-click-fanout', item) }"
                                       @change="(num) => emit('change', num, item)" :type="item.type"
                                       :isEnabledTu="isEnabledTu && item.isEnabledTu" v-model:tu="item.tu" :port="item.portNum" :popover="popover"
                                       :isEnabled="isEnabled && item.isEnabled" :status="item.status" :borderStatus="item.borderStatus"
                                       :value="item.selected"
                                       v-model="item.selected" :hex="item.hex" :mode="item.mode" :detach="item.detach" :lag="item.lag"
                                       :priority="item.priority" :vendor="item.detect" :config="item.config"
                                       :isFanout="checkFanout(item.portNum)"
                >
                  {{ item.value }}
                </sakura-port-lan>
              </template>
            </el-popover>
          </div>
        </div>

        <!-- Layout spacing blocks for right side -->
        <div class="layout-spacer" v-if="list.length > 4"></div>
        <div class="layout-spacer" v-if="list.length > 4"></div>

        <div class="full-size" v-if="list.length === 4 && slotShowLock">
          <div class="flex-container">
            <div class="net-work-port" v-for="(item, index) in slotList(2)" :key="index">
              <div class="port-item" :style="calcStyle(item.portNum)" v-if="index < 2">
                <el-popover placement="top" popper-class="sakura-child-port-popover" trigger="click"
                            :disabled="!checkFanout(item.portNum)" @show="fanoutChange(item.portNum)"
                            @hide="fanoutChange()">
                  <template #reference>
                    <sakura-port-lan @port-click="() => { emit('port-click', item) }"
                                           @port-click-fanout="() => { emit('port-click-fanout', item) }"
                                           @change="(num) => emit('change', num, item)" :type="item.type"
                                           :isEnabledTu="isEnabledTu && item.isEnabledTu" v-model:tu="item.tu" :port="item.portNum" :popover="popover"
                                           :isEnabled="isEnabled && item.isEnabled" :status="item.status" :borderStatus="item.borderStatus"
                                           :value="item.selected"
                                           v-model="item.selected" :hex="item.hex" :mode="item.mode" :detach="item.detach" :lag="item.lag"
                                           :priority="item.priority" :vendor="item.detect" :config="item.config"
                                           :isFanout="checkFanout(item.portNum)" invert :slotShowLock="slotShowLock"
                    >
                      {{ item.value }}
                    </sakura-port-lan>
                  </template>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
<!--      third row-->
      <div class="net-work-row flex-layout align-center" style="position: relative">
        <img v-if="list.length > 4" src="/static/images/common/computer-fan.png" alt="fan"
             style="width: 135px;
                position: absolute;
                bottom: 15%;
                right: 4.5%
    ">
        <!-- Layout spacing blocks for left side -->
        <div class="layout-spacer" v-if="list.length > 4"></div>
        <div class="layout-spacer" v-if="list.length > 4"></div>

        <div class="net-work-port" v-for="(item, index) in list.filter(data => ((data.value % 2) === 0) && data.value > 8)" v-if="list.length > 4">
          <div class="port-item port-item-one" :style="calcStyle(item.portNum)">
            <el-popover placement="top" popper-class="sakura-child-port-popover" trigger="click"
                        :disabled="!checkFanout(item.portNum)" @show="fanoutChange(item.portNum)"
                        @hide="fanoutChange()">
              <template #reference>
                <sakura-port-lan @port-click="() => { emit('port-click', item) }"
                                       @port-click-fanout="() => { emit('port-click-fanout', item) }"
                                       @change="(num) => emit('change', num, item)" :type="item.type"
                                       :isEnabledTu="isEnabledTu && item.isEnabledTu" v-model:tu="item.tu" :port="item.portNum" :popover="popover"
                                       :isEnabled="isEnabled && item.isEnabled" :status="item.status" :borderStatus="item.borderStatus"
                                       :value="item.selected"
                                       v-model="item.selected" :hex="item.hex" :mode="item.mode" :detach="item.detach" :lag="item.lag"
                                       :priority="item.priority" :vendor="item.detect" :config="item.config"
                                       :isFanout="checkFanout(item.portNum)" invert
                >
                  {{ item.value }}
                </sakura-port-lan>
              </template>
            </el-popover>
          </div>
        </div>

        <!-- Layout spacing blocks for fan area -->
        <div class="layout-spacer" v-if="list.length > 4"></div>
        <div class="layout-spacer" v-if="list.length > 4"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, computed, watch } from 'vue'
import sakuraPortLan from "./sakura-port-lan.vue"

const props = defineProps({
  popover: {
    type: Boolean,
    default: () => false
  },
  value: {
    type: Array,
    default: () => []
  },
  multiple: {
    type: Boolean,
    default: () => true
  },
  isEnabled: {
    type: Boolean,
    default: () => true
  },
  isEnabledTu: {
    type: Boolean,
    default: () => false
  },
  slotId: {
    type: String,
    default: () => ''
  },
  list: {
    type: Array,
    default: () => []
  },
  fanout: {
    type: Array,
    default: () => []
  }
})

const emit = defineEmits(['port-click', 'port-click-fanout', 'change'])

const network = inject('network')

const calcStyle = (num) => {
  let obj = {}
  if (!!network.fanoutNum && network.fanoutNum !== num) {
    obj['filter'] = 'blur(3px)'
    obj['pointer-events'] = 'none'
  }
  return obj
}

const checkFanout = (port) => {
  let { fanout } = props
  return fanout && fanout.length && fanout.find(item => item.rootPortNum === port)
}

const fanoutChange = (num) => {
  network.fanoutNum = num
}

const slotShowLock = computed(() => {
  return ['APM414SD','APM414LD',].includes(props.slotId)
})

const slotList=(row)=>{
  if(slotShowLock.value){
    return props.list.filter(data => row === 1 ? !((data.value % 2) === 0) : ((data.value % 2) === 0))
  }
  return props.list
}
</script>


<style lang="scss" scoped>
@import "@/css/base.scss";

.flex-one {
  flex: 1;
}

.align-center {
  align-items: center;
}

.full-size {
  width: 100%;
  height: 100%;
}

.flex-container {
  display: flex;
  width: 100%;
  height: 100%;
}

.net-work-row {
  height: 80px;
}

.net-work-port {
  flex: 1;
  height: inherit;
  min-width: 50px;

  .port-item {
    height: 100%;
    line-height: 50px;
    text-align: center;
    position: relative;
  }

  .port-item-one {
    border-right: 1px solid $network-border-color;
    border-bottom: 1px solid $network-border-color;
  }

  .port-item-two {
    border-right: 1px solid $network-border-color;
  }

  .port-item port-item-one:last-child,
  .port-item port-item-two:last-child {
    border-right: none;
  }
}
.slot-id-header {
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  color: #ccc;
  font-size: 12px;
}

.layout-spacer {
  flex: 1;
  height: inherit;
  min-width: 50px;
  // Optional: add a subtle background for debugging layout
  // background: rgba(255, 255, 255, 0.05);
}
</style>
